@if (weatherData(); as weatherData) {
  @if (weatherData.loading) {
    <div>{{ 'General.LoadingOoo' | translate }}</div>
  }
  @if (weatherData.error) {
    <div>{{ 'Weather.LoadFailed' | translate }}</div>
  }

  @if (weatherData.view; as currentWeatherView) {
    <div class="weather">
      <div class="weather__title">{{ 'Weather.Title' | translate }}</div>
      <div class="weather__buttons">
        @for (option of weatherOptions; track option.value) {
          <dv-button
            [isRound]="true"
            [isSelectedStateActive]="true"
            [selected]="selectedWeather() === option.value"
            (click)="selectWeather(option.value)"
          >
            {{ option.label | translate }}
          </dv-button>
        }
      </div>

      @switch (currentWeatherView.kind) {
        @case ('7hours') {
          <div class="forecast-list">
            <dv-divider direction="horizontal"></dv-divider>
            @for (item of currentWeatherView.data.items; track $index) {
              <div class="forecast-list__row">
                <div>{{ item.time | date: 'HH' }}</div>
                <img
                  width="40px"
                  height="40px"
                  [src]="'assets/weather-icons/' + item.symbolCode + '.svg'"
                />
                <div [style.color]="item.temperatureColor">{{ item.temperature }}°</div>
                <div [ngStyle]="{ opacity: item.precipitationAmount ? 1 : 0 }">
                  {{ item.precipitationAmount }}
                  {{ item.precipitationAmountUnit | lowercase }}
                </div>

                <div class="forecast-list__column">
                  {{ item.windSpeed }}
                  {{ item.windSpeedUnit | lowercase }}
                  <span class="dv-icons" [style.transform]="'rotate(' + item.windRotation + 'deg)'"
                    >wind_direction</span
                  >
                </div>
              </div>
            }
          </div>
        }
        @case ('7days') {
          <div class="forecast-list">
            <dv-divider direction="horizontal"></dv-divider>
            @for (item of currentWeatherView.data.items; track $index) {
              <div class="forecast-list__row">
                <div>
                  {{ item.labelKey | translate }}
                  {{ item.labelKey?.includes('Tomorrow') ? '' : '(' + item.dayOfMonth + ')' }}
                </div>
                <img
                  width="40px"
                  height="40px"
                  [src]="'assets/weather-icons/' + item.symbolCode + '.svg'"
                />
                <div [style.color]="item.temperatureColor">{{ item.temperature }}°</div>
                <div [ngStyle]="{ opacity: item.precipitationAmount ? 1 : 0 }">
                  {{ item.precipitationAmount }}
                  {{ item.precipitationAmountUnit | lowercase }}
                </div>
                <div class="forecast-list__column">
                  {{ item.windSpeed }}
                  {{ item.windSpeedUnit | lowercase }}
                  <span class="dv-icons" [style.transform]="'rotate(' + item.windRotation + 'deg)'"
                    >wind_direction</span
                  >
                </div>
              </div>
            }
          </div>
        }
        @case ('now') {
          <div class="current-weather">
            <div class="current-weather__color-icon">
              <img
                width="40px"
                height="40px"
                [src]="'assets/weather-icons/' + currentWeatherView.data.symbolCode + '.svg'"
              />
            </div>
            <div class="current-weather__info">
              <div class="current-weather__info--icon">
                <span class="dv-icons">temperature</span>
              </div>
              <div
                class="current-weather__info--text"
                [style.color]="currentWeatherView.data.temperatureColor"
              >
                {{ currentWeatherView.data.temperature }} {{ '°C' }}
              </div>
            </div>
            @if (currentWeatherView.data.precipitationAmount; as precipitationAmount) {
              <div class="current-weather__info">
                <div class="current-weather__info--icon">
                  <span class="dv-icons">rain</span>
                </div>
                <div class="current-weather__info--icon">
                  {{ precipitationAmount || 0 }}
                  {{ currentWeatherView.data.precipitationAmountUnit | lowercase }}
                </div>
              </div>
            }
            <div class="current-weather__info">
              <div class="current-weather__info--icon">
                <span class="dv-icons">wind</span>
              </div>
              <div class="current-weather__info--text">
                {{ currentWeatherView.data.windSpeed }}
                {{ currentWeatherView.data.windSpeedUnit | lowercase }}
                @if (currentWeatherView.data.windRotation !== undefined) {
                  <span
                    class="dv-icons"
                    [style.transform]="'rotate(' + currentWeatherView.data.windRotation + 'deg)'"
                    >wind_direction</span
                  >
                }
              </div>
            </div>
          </div>
        }
      }
      <div class="disclaimer">*{{ 'Weather.Disclaimer' | translate }}</div>
    </div>
  }
}
